import * as rankHREmailsCommands from '@RankHR/Emails/commands-vue-composables'
import * as rankHRPeopleCommands from '@RankHR/People/commands-vue-composables'
import * as rankHRPeopleQueries from '@RankHR/People/queries-vue-composables'
import * as rankHRRegionsCommands from '@RankHR/Regions/commands-vue-composables'
import * as rankHRRegionsQueries from '@RankHR/Regions/queries-vue-composables'

export function useDashboardPage(){
	return {
		useAddPersonCommand: rankHRPeopleCommands.useAddPersonCommandV1,
		useCopyPersonVotesCommand: rankHRPeopleCommands.useCopyPersonVotesCommandV1,
		useCreateRegionCommand: rankHRRegionsCommands.useCreateRegionCommandV1,
		useCreateVotingCycleCommand: rankHRRegionsCommands.useCreateVotingCycleCommandV1,
		useDisableAnonymousModeCommand: rankHRRegionsCommands.useDisableAnonymousModeCommandV1,
		useDisablePersonCommand: rankHRPeopleCommands.useDisablePersonCommandV1,
		useEnableAnonymousModeCommand: rankHRRegionsCommands.useEnableAnonymousModeCommandV1,
		useEnablePersonCommand: rankHRPeopleCommands.useEnablePersonCommandV1,
		usePeopleByRegionQuery: rankHRPeopleQueries.usePeopleByRegionQueryV1,
		useRegionQuery: rankHRRegionsQueries.useRegionQueryV1,
		useRemoveVotingCycleCommand: rankHRRegionsCommands.useRemoveVotingCycleCommandV1,
		useSendEmailCommand: rankHREmailsCommands.useSendEmailCommandV1,
		useSetCriteriaVersionCommand: rankHRRegionsCommands.useSetCriteriaVersionCommandV1,
		useStartVotingCycleCommand: rankHRRegionsCommands.useStartVotingCycleCommandV1,
		useStopVotingCycleCommand: rankHRRegionsCommands.useStopVotingCycleCommandV1,
		useSwitchVotingCycleCommand: rankHRRegionsCommands.useSwitchVotingCycleCommandV1,
		useUpdatePersonCommand: rankHRPeopleCommands.useUpdatePersonCommandV1,
		useVotingProgressQuery: rankHRRegionsQueries.useVotingProgressQueryV1,
	}
}

export function useIndividualReportPage(){
	return {
		useIndividualReportQuery: rankHRRegionsQueries.useIndividualReportQueryV1,
	}
}

export function useOverallReportPage(){
	return {
		useOverallReportQuery: rankHRRegionsQueries.useOverallReportQueryV1,
	}
}

export function useSurveyPage(){
	return {
		usePersonVotedCommand: rankHRPeopleCommands.usePersonVotedCommandV1,
		useSurveyByPersonQuery: rankHRRegionsQueries.useSurveyByPersonQueryV1,
	}
}

